/* ============================================================
   UAS blog carousel - click-and-drag (mouse) scrolling for the
   "Latest News and Updates" viewport. Loaded via uas-menu-toggle.liquid.

   - Mouse/pen: press on the cards and drag to move them 1:1.
   - Touch: left untouched (native swipe scrolling already works).
   - Reuses the section's .is-dragging class (snap off while dragging,
     snaps back on release).
   - A real drag suppresses the follow-up click so it doesn't open an article.
   ============================================================ */
(function () {
  var THRESH = 4; // px of movement before a press counts as a drag, not a click

  function attach(vp) {
    if (!vp || vp.dataset.uasbpDrag === '1') return;
    vp.dataset.uasbpDrag = '1';
    vp.style.cursor = 'grab';

    var down = false, moved = false, startX = 0, startLeft = 0, suppress = false;

    function onMove(e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) > THRESH) {
        moved = true;
        vp.classList.add('is-dragging');   // snap/smooth off for 1:1 drag
        vp.style.cursor = 'grabbing';
        vp.style.userSelect = 'none';
      }
      if (moved) {
        vp.scrollLeft = startLeft - dx;    // cards follow the mouse
        e.preventDefault();
      }
    }

    function onUp() {
      if (!down) return;
      down = false;
      document.removeEventListener('pointermove', onMove);
      document.removeEventListener('pointerup', onUp);
      document.removeEventListener('pointercancel', onUp);
      if (moved) {
        vp.classList.remove('is-dragging'); // re-enable snap -> settles on a card
        vp.style.cursor = 'grab';
        vp.style.userSelect = '';
        suppress = true;
        setTimeout(function () { suppress = false; }, 30);
      }
    }

    vp.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return; // leave native touch scrolling alone
      if (e.button !== 0) return;            // left mouse button only
      down = true; moved = false;
      startX = e.clientX;
      startLeft = vp.scrollLeft;
      // listen on document so the drag survives the cursor leaving the viewport
      document.addEventListener('pointermove', onMove);
      document.addEventListener('pointerup', onUp);
      document.addEventListener('pointercancel', onUp);
    });

    // a genuine drag shouldn't navigate: swallow the click it produces
    vp.addEventListener('click', function (e) {
      if (suppress) { e.preventDefault(); e.stopPropagation(); }
    }, true);

    // kill the browser's native image/link drag ghost
    vp.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  function attachAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.uas-blog-posts-section [data-uasbp-viewport]').forEach(attach);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { attachAll(document); });
  } else {
    attachAll(document);
  }
  document.addEventListener('shopify:section:load', function (e) { attachAll(e.target); });
})();
